import React from "react";
import { TableActionGroup } from "../Buttons";

/**
 * CheckCross - Save/Cancel button group for inline table edits
 * Used in task tables and other inline edit scenarios
 * 
 * @param {Object} props
 * @param {function} props.handleAddEditRow - Save handler
 * @param {function} props.handleCancel - Cancel handler
 * 
 * @example
 * <CheckCross handleAddEditRow={handleSave} handleCancel={handleCancel} />
 */
const CheckCross = ({ handleAddEditRow, handleCancel, loading }) => {
  return (
    <TableActionGroup
      mode="editing"
      onSave={handleAddEditRow}
      onCancel={handleCancel}
      loading={loading}
    />
  );
};

export default CheckCross;
